import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../../action/webViewContentAction.js';
import './ModalTip.css';
import { protocolCode } from '../../BankCode';
import {
  hashHistory
} from 'react-router';

class ModalList extends Component {
  state = {
    agreeIndex: 0,
  }

  componentWillMount = () => {
    
  }

  goBacks = () => {
    if(this.state.agreeIndex=="1"){
      this.setState({
        agreeIndex: 0
      })
      this.props.onFun(false)
    }else{
      this.setState({
        agreeIndex: 1
      })
      this.props.onFun(true)
    }
  }

  YueDu = () => {
    let name='用户同步信息授权书'
		let code=protocolCode[name];
    hashHistory.push({
      pathname:'/WebView',
      state:{name:name,code:code},
      query: {code:code}
    })
  }

  render = () => {
    let { flag, content, title, btnRight, btnLeft, btnLeftFun, btnRightFun, onFun, btnLift, btnLiftFun } = this.props;
    const img_arr = [require('../../img/square@3x.png'),require('../../img/squareHooks@3x.png')]
    const stylesFir = {display: "-webkit-flex", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", height: window.winHeight, width: window.winWidth};
    const stylesSec = {display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", width: window.winWidth};
    return (
      <div>
        {
          flag ? 
          <div style={this.props.heightAll ? stylesSec : stylesFir}>
            <div style={{backgroundColor: "#fff", width: 271, borderRadius: 10}}>
              <div style={{fontSize: 13, color: "#3a3e47", textAlign: "center", paddingTop: 30}}>{title}</div>
              <div style={{fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 20, paddingBottom: 25, borderBottom: "1px solid #ebeef0"}}>{content}</div>
              {
                onFun?
                <div style={{fontSize: 12, color: "#3a3e47", textAlign: "center", paddingTop: 10,display:"flex",alignItems:"center"}}><img style={{width:"0.4rem",height:"0.4rem"}} onClick={this.goBacks} src={img_arr[this.state.agreeIndex]} />我已阅读并同意《<span onClick={this.YueDu} style={{color:"red"}}>用户同步信息授权书</span>》</div>
                :
                null
              }
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitJustifyContent: "space-evenly", height: 40, WebkitAlignItems: "center"}}>
                {
                  btnLeftFun ?
                  <div onClick={btnLeftFun} style={{fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>{btnLeft}</div>
                  :
                  null
                }
                {
                  btnLeftFun && btnRightFun ?
                  <div style={{width:1, backgroundColor: "#fa063a", height: 20}}></div>
                  :
                  null
                }
                {
                  btnLiftFun ?
                  <div onClick={btnLiftFun} style={{fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>{btnLift}</div>
                  :
                  null
                }
                {
                  btnRightFun ?
                  <div onClick={btnRightFun} style={{fontSize: 15, color: "#fa063a", display: "-webkit-flex", height: "100%", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>{btnRight}</div>
                  :
                  null
                }
              </div>
            </div>
          </div> 
          :
          null
        }
      </div>
    );
  }
}

export default ModalList;

export class AddCardHqtAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="closeIcon" onClick={ ()=>{ this.props.CloseAler() } }>
              
            </div>
            <div style={{ paddingLeft:"20px", paddingRight:"20px",paddingTop:'20px' }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:17 }}>{ this.props.title }</div>
              <div style={{ fontSize:15, lineHeight:"20px" }}>
                { this.props.content }
              </div>
              <div style={{ height:"30px" }}></div>
              <div className="alertOk_div" style={{ marginBottom:"10px"}}>
                <div onClick={ ()=>{ this.props.handleBtn1() } }style={{border:"1px solid #FE492E", width:"100%", backgroundColor:"#FFF", height:"40px", color:"#FE492E", textAlign:"center", lineHeight:"40px" }}>
                  {this.props.btnfirText}
                </div>
              </div>
              <div className="alertOk_div">
                <div onClick={ ()=>{ this.props.handleBtn2() } }style={{border:"1px solid #FE492E", width:"100%", backgroundColor:"#FFF", height:"40px", color:"#FE492E", textAlign:"center", lineHeight:"40px" }}>
                  {this.props.btnsecText}
                </div>
              </div>
              <div style={{height:"40px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}


export class SuperModalTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  handleCancel = () => {
    this.props.handleCancel()
  }
  handleBtnOne = () => {
    this.props.handleBtnOne()
  }
  handleBtnTwo = () => {
    this.props.handleBtnTwo()
  }
  render() {
    const { buttonText1,  buttonText2 } = this.props;
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
    <div style={{ width:"300px", background:"#FFF", borderRadius:"20px", position:"relative" }}>
            <div className="closeIcon" onClick={ ()=>{ this.handleCancel() } }>
              
            </div>
            <div style={{ paddingLeft:"20px", paddingRight:"20px",paddingTop:'20px' }}>
              <div style={{textAlign:"center", marginBottom:"20px", fontSize:17 }}>{ this.props.title }</div>
              <div style={{ fontSize:15, lineHeight:"20px" }}>
                { this.props.content }
              </div>
              <div style={{ height:"30px" }}></div>
              <div className="alertOk_div" style={{ marginBottom:"10px"}}>
                <div onClick={ ()=>{ this.handleBtnOne() } }style={{border:"1px solid #FE492E", width:"100%", backgroundColor:"#FA063A", height:"40px", color:"#FFF", textAlign:"center", lineHeight:"40px" }}>
                  {buttonText1}
                </div>
              </div>
              <div className="alertOk_div">
                <div onClick={ ()=>{ this.handleBtnTwo() } }style={{border:"1px solid #FE492E", width:"100%", backgroundColor:"#FFF", height:"40px", color:"#FE492E", textAlign:"center", lineHeight:"40px" }}>
                  {buttonText2}
                </div>
              </div>
              <div style={{height:"40px"}}></div>
            </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalList.js